import type { Variants, Transition } from 'framer-motion';

// Page transitions are disabled — all variants render at full opacity with
// zero-duration transitions. PageTransition still runs (for startTransition
// + lazy-chunk preload so we don't flash ActionLoader), but no visible
// animation is applied. Earlier opacity-fade caused more harm than good
// during interactive nav (jerky, content-flashing).

const NO_ANIM_VARIANTS: Variants = {
  enter: { opacity: 1 },
  center: { opacity: 1 },
  exit: { opacity: 1 },
};

const NO_ANIM_TRANSITION: Transition = { duration: 0 };

export const tabVariants = NO_ANIM_VARIANTS;
export const tabTransition = NO_ANIM_TRANSITION;

export const pushVariants = NO_ANIM_VARIANTS;
export const pushTransition = NO_ANIM_TRANSITION;

export const popVariants = NO_ANIM_VARIANTS;
export const popTransition = NO_ANIM_TRANSITION;

export const expandVariants = NO_ANIM_VARIANTS;
export const expandTransition = NO_ANIM_TRANSITION;

export const replaceVariants = NO_ANIM_VARIANTS;
export const replaceTransition = NO_ANIM_TRANSITION;
